import { ACPage } from 'academy-navigation-lib/components/ACPage/ACPage';
import { useIsPartner } from '../../partners/partnersQueries';
import { useHasGate } from '../../accounts/accountsQueries';
import { PLAYLIST_URL_FRAGMENT, PRACTICE_MODE_URL_FRAGMENT, SHARE_AWARD_URL_FRAGMENT, SHORT_URL_FRAGMENT, SOFTWARE_DISCOVERY_TOOL_RECOMMENDATIONS, LESSONS_URL_FRAGMENT, TRACKS_URL_FRAGMENT } from '../../../constants/Navigation';
import { matchPath, useLocation } from 'react-router-dom';
import { FullScreen } from 'foundations-components/transitional/components/FullScreen';
import { MyPlaylistsRoutePaths } from '../../../routes';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const fullScreenPaths = [{
  path: '/',
  exact: true
}, {
  path: TRACKS_URL_FRAGMENT,
  exact: false
}, {
  path: LESSONS_URL_FRAGMENT,
  exact: false
}, {
  path: SHORT_URL_FRAGMENT,
  exact: false
}, {
  path: PLAYLIST_URL_FRAGMENT,
  exact: false
}];
const editorPagePaths = [{
  path: PRACTICE_MODE_URL_FRAGMENT,
  exact: false
}, {
  path: SHARE_AWARD_URL_FRAGMENT,
  exact: false
}, {
  path: `/${SOFTWARE_DISCOVERY_TOOL_RECOMMENDATIONS}`,
  exact: false
}];
const useIsFullScreenPage = () => {
  const location = useLocation();
  const isMyPlaylistPage = matchPath(location.pathname, {
    path: MyPlaylistsRoutePaths,
    exact: true
  });
  return !isMyPlaylistPage && fullScreenPaths.find(config => matchPath(location.pathname, config)) !== undefined;
};
const useIsEditorPage = () => {
  const location = useLocation();
  return editorPagePaths.find(config => matchPath(location.pathname, config)) !== undefined;
};
export const NavPage = ({
  children
}) => {
  const isPartner = useIsPartner();
  const fullScreen = useIsFullScreenPage();
  const isEditorPage = useIsEditorPage();
  const {
    hasGate: isUngatedForUnifiedAcademyNavigation
  } = useHasGate('Academy:UnifiedAcademy:Navigation');
  if (!isUngatedForUnifiedAcademyNavigation) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: children
    });
  }
  if (isEditorPage) {
    return /*#__PURE__*/_jsx(FullScreen, {
      children: /*#__PURE__*/_jsx(_Fragment, {
        children: children
      })
    });
  }
  return /*#__PURE__*/_jsx(ACPage, {
    fullScreen: fullScreen,
    isPartner: !!isPartner,
    children: children
  });
};